import { createApis } from 'saga-slice-helpers';
import { checkForUnauthorized, returnAnalyticsApi } from './utils';
import { API_TIMEOUT } from '../../constants';
import { getAnalyticsSessionId } from '../app/utils';

const { api } = createApis({
  baseURL: returnAnalyticsApi(),
  headers: { source: 'ETR2' },
  timeout: API_TIMEOUT,
});

api.instance.interceptors.response.use(
  (res) => res,
  async (err) => {
    return await checkForUnauthorized(err);
  },
);

api.instance.interceptors.request.use(
  (config) => {
    const analyticsSessionId = getAnalyticsSessionId();
    config.headers['analytics-session-id'] = analyticsSessionId;

    if (config.data) {
      if (
        config.url &&
        config.url.includes('/event') &&
        config.data === 'object'
      ) {
        try {
          config.data['sessionId'] = analyticsSessionId;
        } catch (e) {
          console.error(
            'Could not parse request body for analytics session Id injection',
            e,
          );
        }
      }

      return {
        ...config,
        data: JSON.parse(JSON.stringify(config.data).replaceAll('/', '')),
      };
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

export { api };
